import { NgModule } from '@angular/core';
import {SpinnerComponent} from "./spinner.component";
import {DialogModule} from "primeng/primeng";

@NgModule({
    imports: [
        DialogModule,
    ],
    exports: [
        SpinnerComponent
    ],
    declarations: [SpinnerComponent]
})
export class SpinnerModule {}



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.module.ts